module.exports = __webpack_public_path__ + "static/media/spoonerism-task (11).c634c115.mp3";